<template>
  <div>
    <Tachi15Hero />
    <Tachi15Home
      @changeShowContactForm="ShowContactForm = !ShowContactForm"
    ></Tachi15Home>
    <transition name="contact-form">
      <Tachi15ContactForm v-if="ShowContactForm"></Tachi15ContactForm>
    </transition>
    <Footer />
  </div>
</template>

<script>
import Tachi15Hero from "@/components/Tachi15Hero.vue";
import Tachi15Home from "@/components/Tachi15Home.vue";
import Tachi15ContactForm from "@/components/Tachi15ContactForm.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Tachi15Hero,
    Tachi15Home,
    Footer,
    Tachi15ContactForm
  },
  data() {
    return { ShowContactForm: false };
  }
};
</script>

<style>
.contact-form-enter,
.contact-form-leave-to {
  opacity: 0;
  transform: rotateY(50deg);
}
.contact-form-enter-to,
.contact-form-leave {
  opacity: 1;
  transform: rotateY(0deg);
}
.contact-form-enter-active,
.contact-form-leave-active {
  transition: opacity, transform 200ms ease-out;
}
</style>